document.addEventListener('DOMContentLoaded', function() {
    class CartBundle extends HTMLElement {
        constructor() {
          super();
          this.removeButton = this.querySelector(".ds-bundle--remove");
        }
      
        connectedCallback() {
          if (this.removeButton) {
            this.removeButton.addEventListener("click", this.removeBundle.bind(this));
          }
        }
      
        async removeBundle(event) {
          event.preventDefault();
      
          const lineItems = this.querySelectorAll("[data-line-key]");
          const updates = {};
          lineItems.forEach((item) => {
            const key = item.getAttribute("data-line-key");
            updates[key] = 0;
          });
      
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ updates: updates })
            });
      
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
      
            const result = await response.json();
      
            // Aktuellen Warenkorb abrufen
            const currentCartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const currentCartData = await currentCartResponse.json();
      
            // UI aktualisieren
            document.dispatchEvent(new CustomEvent('cart:build'));
      
            // Cart-Change-Event auslösen
            document.dispatchEvent(new CustomEvent('cart:change', {
              detail: { cart: { item_count: currentCartData.item_count } },
              bubbles: true,
              composed: true
            }));
      
            // Cart-Refresh-Event auslösen
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              composed: true
            }));
      
            // Optional: Cart-Drawer aktualisieren
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.querySelector('cart-drawer-items').refreshCart();
            }
      
          } catch (error) {
            console.error('Error:', error);
            alert('Es gab ein Problem beim Entfernen der Produkte aus dem Warenkorb. Bitte versuchen Sie es erneut.');
          }
        }
      }
      
      if (!window.customElements.get("cart-bundle")) {
        window.customElements.define("cart-bundle", CartBundle);
      }       
});